export function formatPercentage(percentage: number) {
  return `${percentage.toFixed(2)}%`
}
